export default __webpack_public_path__ + "static/media/searchIcon.88dae093.svg";